<p-table
    #table
    [value]="casts"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm"
    [paginator]="true"
    [showCurrentPageReport]="true"
    [rowHover]="true"
    [globalFilterFields]="['cast', 'ruolo']"
    currentPageReportTemplate="{first} di {last} su {totalRecords} persone"
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca cast…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">
                <button class="flex-1 acc-btn" type="button" (click)="add = true">
                    <i class="bi bi-plus"></i>
                    Aggiungi cast
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="w-1/12"></th>
            <th class="w-5/12">Ruolo</th>
            <th class="w-5/12">Cast</th>
            <th class="w-1/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-cast let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
            </td>
            <td><span class="cell-nome">{{cast.ruolo || '-'}}</span></td>
            <td>{{cast.cast || '-'}}</td>
            <td class="text-center">
                <div class="table-actions">
                    <i class="bi bi-pencil" (click)="onOpenEdit(cast)" pTooltip="Modifica" tooltipPosition="bottom"></i>
                    <p-divider layout="vertical"></p-divider>
                    @if (cast.id) {
                        <p-confirmPopup #delete>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteCast()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteCast()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteCast($event, cast, index)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    } @else {
                        <i class="bi bi-trash" (click)="casts.splice(index, 1)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    }
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">Nessuno cast presente.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [visible]="(add || edit)" [style]="{width: '50%'}" [header]="add ? 'Aggiungi cast' : 'Modifica cast'" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal()">
    <ng-template pTemplate="content">
        <form [formGroup]="formCast" class="accrediti-form flex flex-col gap-6">
            <div class="fld">
                <label>* Ruolo</label>
                <p-autoComplete formControlName="ruolo" [suggestions]="ruoli_filtrati" field="ruolo" appendTo="body" class="autocomplete w-full" [showEmptyMessage]="false" [dropdown]="true" (completeMethod)="onFilterRuoli($event)" required />
            </div>
            <div class="fld">
                <label>Cast</label>
                <input type="text" pInputText class="w-full" formControlName="cast" />
            </div>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal()">Annulla</button>
                @if (add) {
                    <button type="button" class="acc-btn" [disabled]="!formCast.valid" (click)="onAdd(true)">Aggiungi e continua</button>
                }
                <button type="button" class="acc-btn acc-btn-primary" [disabled]="!formCast.valid" (click)="add ? onAdd(false) : onEdit()">{{add ? 'Aggiungi' : 'Modifica'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
